if (!customElements.get('td-unit-breakdown')) {
  class TdUnitBreakdown extends HTMLElement {
    constructor() {
      super();
      this.UNIT_BREAKDOWN_DATA = this.dataset.unitBreakdowns ? this.getJson(this.dataset.unitBreakdowns) : null;
    }

    connectedCallback() {
      if (!this.UNIT_BREAKDOWN_DATA) return;
      this.attachListeners();
    }

    attachListeners() {
      document.addEventListener('td:variant-changed', this.updateUnitBreakdown.bind(this));
    }

    updateUnitBreakdown(event) {
      const selectedUnitBreakdown = this.UNIT_BREAKDOWN_DATA[event.detail?.selected_variant?.id];
      if (!selectedUnitBreakdown) return;

      const { retail_units, free_units, off_msrp } = selectedUnitBreakdown;
      if (retail_units && free_units) {
        this.innerHTML = `${retail_units} + ${free_units}`;
      } else if (free_units) {
        this.innerHTML = `+ ${free_units}`;
      }

      if (off_msrp) {
        this.innerHTML = off_msrp;
      }
    }

    getJson(str) {
      try {
        return JSON.parse(str);
      } catch (err) {
        console.error('Failed to parse JSON:', err);
        return null;
      }
    }
  }

  customElements.define('td-unit-breakdown', TdUnitBreakdown);
}
